<template>
  <span 
    :class="getBadgeClass(estado)"
    class="px-3 py-1 rounded-full text-sm font-semibold inline-flex items-center gap-1.5"
  >
    <span>{{ getIcono(estado) }}</span>
    <span>{{ estado }}</span>
  </span>
</template>

<script>
export default {
  name: 'SemaforoBadge',
  props: {
    estado: {
      type: String,
      required: true
    }
  },
  methods: {
    getBadgeClass(estado) {
      switch (estado) {
        case 'VERDE':
          return 'bg-green-100 text-green-800 border border-green-300';
        case 'AMARILLO':
          return 'bg-yellow-100 text-yellow-800 border border-yellow-300';
        case 'NARANJA':
          return 'bg-orange-100 text-orange-800 border border-orange-300';
        case 'ROJO':
          return 'bg-red-100 text-red-800 border border-red-300';
        default:
          return 'bg-gray-100 text-gray-800 border border-gray-300';
      }
    },
    getIcono(estado) {
      switch (estado) {
        case 'VERDE':
          return '🟢';
        case 'AMARILLO':
          return '🟡';
        case 'NARANJA':
          return '🟠';
        case 'ROJO':
          return '🔴';
        default:
          return '⚪';
      }
    }
  }
};
</script>
